import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { CALLING_CODE_ACTION_TYPE } from "./calling-code.action";
import { CallingCodeState } from "./calling-code.model";

const initialState: CallingCodeState = {};
/**
 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
 */
export function callingCodeReducer(state = initialState, action: ActionWithPayload): CallingCodeState {
	switch (action.type) {
		case CALLING_CODE_ACTION_TYPE.getAllSuccess: {
			return updateState(state, {
				singleMarketCallingCodes: action.payload?.singleMarketCallingCodes,
				singleMarketCallingCodesWithCountryCode: action.payload?.singleMarketCallingCodesWithCountryCode,
			});
		}
		default:
			return state;
	}
}
